import { useHealthblocksSWR, useSubjectId } from '@healthblocks-io/core'

import type { SWRConfiguration } from 'swr'
import type { QuestionnaireCareplanActivityWithIncludes } from '../types/questionnaire.types'

export function useQuestionnaireCareplanActivity(idOrSlug?: string, swrOptions?: SWRConfiguration) {
  const subjectId = useSubjectId()
  const queryParameters = new URLSearchParams()

  if (subjectId) {
    queryParameters.append('subjectId', String(subjectId))
  }

  const queryString = queryParameters.toString()

  return useHealthblocksSWR<QuestionnaireCareplanActivityWithIncludes>(
    idOrSlug ? `/views/patient/questionnaire-activity/${idOrSlug}${queryString ? `?${queryString}` : ''}` : null,
    swrOptions,
  )
}
